import { render, staticRenderFns } from "./Sldentfy.vue?vue&type=template&id=6bf898fa&scoped=true"
import script from "./Sldentfy.vue?vue&type=script&lang=js"
export * from "./Sldentfy.vue?vue&type=script&lang=js"
import style0 from "./Sldentfy.vue?vue&type=style&index=0&id=6bf898fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf898fa",
  null
  
)

export default component.exports